import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import CheckBox from '../../../common/CheckBox/index';
import ContentCard from '../../../common/ContentCard';
import AutoCompleteTaggedField from '../../../common/AutoCompleteTaggedField';
import FormInput from '../../../common/FormInput/index';
import CustomSlider from '../../../common/Slider/index';
import DatePicker from '../../../common/DatePicker';
import PropTypes from 'prop-types';
import { transformMapData } from '../../../map/transformers/';
import { noop } from '../../../common/propTypes';
import './styles.scss';
import { connect } from 'react-redux';
import {
    tagsListRequested,
    litterReportRequested,
    litterReportCountRequested,
    clearSelectedFilter,
} from '../actions';
import {
    getCountries,
    getTags,
    isReportLoading,
    getLitterReport,
    getLitterReportCount,
    getReportSuccessMessage,
    getMapData,
    isMapLoading,
} from '../selectors';
import PreviewTable from '../PreviewTable';
import SendReport from '../SendReport';

function GenerateReports({
    countries,
    tags,
    onLoad,
    reportData,
    isReportLoading,
    generateReport,
    reportRowCount,
    onClearFilter,
    reportSuccess,
    mapData,
    isMapLoading,
}) {
    const [activePage, setActivePage] = useState(1);

    const PublicMessage = () => (
        <>
            <p>
                The self-serve form above will give you access to data that was
                collected until the{' '}
                <strong>16th of March 2022, 1:00 PM EST.</strong>
            </p>
            <p>
                If you require data that was collected after, please complete
                the Expanded Data Request Form below.
            </p>
            <p>
                If you have any questions, please reach out to us at{' '}
                <strong>support@litterati.org</strong>. Thank you for your
                understanding.
            </p>
        </>
    );

    const reportContent =
        reportData && reportData.length ? (
            <>
                <PreviewTable
                    preview={reportData}
                    totalCount={reportRowCount}
                    loading={isReportLoading}
                    currentPage={activePage}
                    onPageChange={(pageNo) => {
                        setActivePage(pageNo);
                        generateReport({
                            selectedCountries,
                            selectedTags,
                            selectedStartDate,
                            selectedEndDate,
                            selectedZipcode,
                            selectedRadius,
                            offset: (pageNo - 1) * 5,
                        });
                    }}
                    mapData={mapData}
                    isMapLoading={isMapLoading}
                />
                <SendReport />
            </>
        ) : reportSuccess && !reportData.length ? (
            <div className="container">
                <div className="row mt-4 ml-3">
                    <div className="alert alert-info">NO DATA FOUND</div>
                </div>
            </div>
        ) : (
            <>
                <div className="container">
                    <div className="row mt-5">
                        <ContentCard
                            heading={'Please Note'}
                            content={<PublicMessage />}
                        />
                    </div>
                </div>

                <section className="TableWrapper primary-highlight report-placeholder text-center">
                    <div className="row">
                        <div className="col">
                            Generated report will be visible here
                        </div>
                    </div>
                </section>

                <p className="text-center">
                    If you require more than 50,000 pieces of data or require
                    custom parameters, please complete the form below.
                </p>
            </>
        );

    const [tagsAllSelected, setTagsAllSelected] = useState(true);

    // state of countries selected by the user and function to pass to autocomplete
    // to update the state on selection
    const [selectedCountries, setSelectedCountries] = useState([]);

    // state of tags selected by the user and function to pass to autocomplete
    // to update the state on selection
    const [selectedTags, setSelectedTags] = useState([]);

    // state of startDate selected by the user and function to pass to datepicker
    // to update the state on selection
    const [selectedStartDate, setSelectedStartDate] = useState(null);

    // state of endDate selected by the user and function to pass to datepicker
    // to update the state on selection
    const [selectedEndDate, setSelectedEndDate] = useState(null);

    // state of radius selected by the user and function to pass to slider
    // to update the state on selection
    const [selectedRadius, setSelectedRadius] = useState(0);

    // state of zipcode entered by the user and function to
    // update the state on input
    const [selectedZipcode, setSelectedZipcode] = useState(null);

    function setFilledState(id, isSelected, setSelectedState) {
        // if checkbox was false and is being set to true then clear selection
        // and unselect all tag pills
        if (!isSelected) {
            clearSelection(id, setSelectedState);
        }
    }

    function clearSelection(id, cb) {
        clearAutocompleteState(id);
        cb([]);
    }

    function clearAutocompleteState(id) {
        document
            .getElementById(id) // call clear event of AutoComplete field
            .parentNode.getElementsByClassName(
                'MuiAutocomplete-clearIndicator',
            )[0]
            .click();
    }

    useEffect(() => {
        if (activePage != 1) setActivePage(1);

        onClearFilter();
        onLoad();
    }, []);

    return (
        <>
            <section className="GenerateReports">
                <div className="container">
                    <div className="verticalSpace">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="f-64 p-0 extraBold">
                                    Generate Report
                                </h1>
                                <div className="reportWrapper">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="clearWraper">
                                                <CheckBox
                                                    id={'all'}
                                                    className="checkCard"
                                                    label={'All'}
                                                    selected={tagsAllSelected}
                                                    onClick={() => {
                                                        setFilledState(
                                                            'tags-autocomplete',
                                                            tagsAllSelected,
                                                            setSelectedTags,
                                                        );
                                                        setTagsAllSelected(
                                                            !tagsAllSelected,
                                                        );
                                                    }}
                                                />
                                                <a
                                                    className="clear"
                                                    onClick={() =>
                                                        clearSelection(
                                                            'tags-autocomplete',
                                                            setSelectedTags,
                                                        )
                                                    }
                                                >
                                                    Clear
                                                </a>
                                            </div>
                                            <AutoCompleteTaggedField
                                                title="Tags"
                                                options={tags}
                                                id="tags-autocomplete"
                                                loading={!tags.length}
                                                bootstrapIcon="icon-tags"
                                                placeholder={
                                                    'Add Tags (ex: food)'
                                                }
                                                onSelect={(tags) => {
                                                    setSelectedTags(tags);
                                                    if (tagsAllSelected) {
                                                        setTagsAllSelected(
                                                            false,
                                                        );
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <AutoCompleteTaggedField
                                                title="Country"
                                                options={countries}
                                                loading={!countries.length}
                                                id="countries-autocomplete"
                                                bootstrapIcon="icon-globe"
                                                placeholder={
                                                    'Add Countries (ex: Canada)'
                                                }
                                                onSelect={(countries) => {
                                                    setSelectedCountries(
                                                        countries,
                                                    );
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <FormInput
                                                title="Zip Code/City"
                                                bootstrapIcon="icon-location-filled"
                                            >
                                                <TextField
                                                    placeholder={
                                                        'Enter Zipcode'
                                                    }
                                                    onChange={(event) =>
                                                        setSelectedZipcode(
                                                            event.target.value,
                                                        )
                                                    }
                                                />
                                            </FormInput>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="rangeSlider">
                                                <h3 className="titleStyle2">
                                                    Radius
                                                </h3>
                                                <CustomSlider
                                                    handleChange={
                                                        setSelectedRadius
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-6">
                                                    <DatePicker
                                                        title="Start Date"
                                                        bootstrapIcon="icon-calendar-empty"
                                                        handleDateChange={
                                                            setSelectedStartDate
                                                        }
                                                    />
                                                </div>
                                                <div className="col-6">
                                                    <DatePicker
                                                        title="End Date"
                                                        bootstrapIcon="icon-calendar-empty"
                                                        handleDateChange={
                                                            setSelectedEndDate
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col pl-2">
                                        <button
                                            type="button"
                                            className="btn btn-custom"
                                            disabled={isReportLoading}
                                            onClick={() => {
                                                if (activePage != 1)
                                                    setActivePage(1);
                                                generateReport({
                                                    selectedCountries,
                                                    selectedTags,
                                                    selectedStartDate,
                                                    selectedEndDate,
                                                    selectedZipcode,
                                                    selectedRadius,
                                                });
                                            }}
                                        >
                                            {isReportLoading
                                                ? 'Loading...'
                                                : 'Generate'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {reportContent}
        </>
    );
}

GenerateReports.propTypes = {
    countries: PropTypes.array,
    tags: PropTypes.array,
    onLoad: PropTypes.func,
    reportData: PropTypes.array,
    isReportLoading: PropTypes.bool,
    // indicates whether the map data has loaded or not
    isMapLoading: PropTypes.bool,
    generateReport: PropTypes.func,
    reportRowCount: PropTypes.number,
    onClearFilter: PropTypes.func,
    reportSuccess: PropTypes.bool,
    // map pointers to be shown for the current report
    mapData: PropTypes.array,
};

GenerateReports.defaultProps = {
    countries: [],
    tags: [],
    onLoad: noop,
    generateReport: noop,
    reportData: [],
    isReportLoading: false,
    isMapLoading: false,
    mapData: [],
    reportRowCount: 0,
    onClearFilter: noop,
    reportSuccess: false,
};

const mapStateToProps = (state) => {
    return {
        countries: getCountries(state),
        tags: getTags(state),
        reportData: getLitterReport(state),
        isReportLoading: isReportLoading(state),
        reportRowCount: getLitterReportCount(state),
        reportSuccess: getReportSuccessMessage(state),
        mapData: transformMapData(getMapData(state)),
        isMapLoading: isMapLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: () => {
            dispatch(tagsListRequested());
        },
        generateReport: (selectedFilter) => {
            dispatch(litterReportRequested(selectedFilter));
            dispatch(litterReportCountRequested(selectedFilter));
        },
        onClearFilter: () => dispatch(clearSelectedFilter()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GenerateReports);
